import { DatePipe } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { BreadCrumbsService } from "app/helper-components/breadcrumbs/breadcrumbs.service";
import { UiService } from "app/helper-components/UiService";
import { BARACK_NAMES, Constants } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { UserDataService } from "app/helpers/user-data.service";
import { PinViewComponent } from "app/main/pin-view/pin-view.component";
import { SurveyAvailableDialogComponent } from "app/main/survey/survey-available-dialog/survey-available-dialog.component";
@Component({
  selector: "app-subnav",
  templateUrl: "./subnav.component.html",
  styleUrls: ["./subnav.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  animations: fuseAnimations,
})
export class SubnavComponent implements OnInit, AfterViewInit {
  // New Roles
  selected_role: any;
  barrack_role: any;
  // selected_role: string = "Party Positions";
  selected_post: any = "Party Positions";
  selected_barrack: string = "Barracks";
  todayNumber: number = Date.now();
  todayDate: Date = new Date();
  todayString: string = new Date().toDateString();
  todayISOString: string = new Date().toISOString();
  parameters: any;
  dialogRef: any;
  pinDialog: MatDialogRef<PinViewComponent> = null;
  place: any;
  barracks = Object.keys(BARACK_NAMES).map((val) => {
    return {
      barrack_id: val,
      barrack_name: BARACK_NAMES[val],
    };
  });

  get showBarracksDropDown(): boolean {
    // return (
    //   this.parameters &&
    //   (this.parameters?.party_post_group_id == 1 ||
    //     this.parameters?.party_post_group_id == 21 ||
    //     this.parameters?.party_post_group_id == 5)
    // );
    return true;
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    this.uiService.hideLoading();
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private _userDataService: UserDataService,
    private helper: HelperService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private _matDialog: MatDialog,
    private uiService: UiService,
    private breadCrumbsService: BreadCrumbsService,
    private userDataService: UserDataService
  ) {
    _router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        let self = this;
        setTimeout(function () {
          self.breadCrumbsService.updateBreadcrumb();
        }, 100);
        this.activatedRoute.queryParams.subscribe((data) => {
          this.parameters = this.helper.getParameters(data["_v"]);
          if (
            this.parameters &&
            this.parameters.hasOwnProperty("lp_party_post_subgroup_id")
          ) {
            let lp_party_post_subgroup_id =
              this.parameters.lp_party_post_subgroup_id;
            this.userData.party_posts?.forEach((element) => {
              if (lp_party_post_subgroup_id == element.party_post_subgroup_id) {
                this.selected_role = element.party_post_subgroup_name;
              }
            });

            let party_post_id = this.parameters.party_post_id;
            this.userData.party_posts?.forEach((element) => {
              if (party_post_id == element.party_post_id) {
                localStorage.removeItem("dataSource");
                this.selected_role = element.party_post_subgroup_name;
                this.place = element.place_name;
              }
            });

            cdr.detectChanges();
          }
          if (this.parameters && this.parameters.hasOwnProperty("barrack_id")) {
            let barrack_id = this.parameters.barrack_id;
            this.barracks.forEach((element) => {
              if (barrack_id == element.barrack_id) {
                localStorage.removeItem("BarrackData");
                this.selected_barrack = element.barrack_name;
                this.barrack_role = element.barrack_name;
                localStorage.setItem("BarrackData", element.barrack_name);
              }
            });
            cdr.detectChanges();
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((val) => {
      this.parameters = this.helper.getParameters(val["_v"]);
    });
    this.selected_role = localStorage.getItem("dataSource");
    this.barrack_role = localStorage.getItem("BarrackData");
  }

  onBarrackChange(menuItem: any) {
    localStorage.removeItem("BarrackData");
    this.selected_barrack = menuItem.barrack_name;
    this.barrack_role = menuItem.barrack_name;
    this.cdr.detectChanges();

    this.activatedRoute.params.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
      if (this.parameters == null) {
        this.activatedRoute.queryParams.subscribe((data) => {
          this.parameters = this.helper.getParameters(data["_v"]);
          if (this.parameters) {
            this.parameters.barrack_id = menuItem.barrack_id;
            this.helper.storePageData(this.parameters, data["_v"]);
          }
        });
      } else {
        this.parameters.barrack_id = menuItem.barrack_id;
        this.helper.storePageData(this.parameters, data["_v"]);
      }
    });
    localStorage.setItem("BarrackData", menuItem.barrack_name);
    this._userDataService.barrackChangeEvent.next(menuItem.barrack_id);

    // let key = this.helper.storePageData(this.parameters);
    // this._router.navigateByUrl("/post/chief_barrack_executive?_v=" + key);
  }

  onPartyPostChange(menuItem: any) {
    localStorage.removeItem("dataSource");

    const callback = (status) => {
      if (status == 1) {
        this.breadCrumbsService.resetBreadCrumb();
        localStorage.setItem(
          this.helper.getMangledName("verified"),
          this.helper.getMangledName("1")
        );

        this.selected_role = menuItem.party_post_subgroup_name;
        this.place = menuItem.place_name;
        let countryData = menuItem.country_data;
        var country_id = -1;
        var country_name = "";
        if (countryData) {
          if (countryData.hasOwnProperty("country_id"))
            country_id = countryData.country_id;
          if (countryData.hasOwnProperty("country_name"))
            country_name = countryData.country_name;
        }

        if (
          menuItem.status == 98 &&
          menuItem.survey.filter((elm) => {
            return elm.submitted == null;
          }).length > 0
        ) {
          let instance = this._matDialog.open(SurveyAvailableDialogComponent);
          instance.componentInstance.title = menuItem.survey[0].title;
          instance.componentInstance.onSubmitCallback = () => {
            let key = this.helper.storePageData(menuItem);
            this._router.navigate(["/survey/", key, 0]);
            instance.close();
          };
        }

        this._userDataService.barrackChangeEvent.next(menuItem.barrack_id);

        if (menuItem.lp == Constants.CONSTITUENCY_SECRETARY) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data: any = {
            barrack_id: menuItem.barrack_id,
            const_id: menuItem.Const_Id,
            const_name: menuItem.Const_name,
            country_name: country_name,
            country_id: country_id,
            constituency_index: menuItem.constituency_index,
            lp: menuItem.lp,
            party_post_id: menuItem.party_post_id,
            district_id: menuItem.district_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            lp_party_post_subgroup_id: menuItem.party_post_subgroup_id,
            party_post_group_id: menuItem.party_post_group_id,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };

          if ([6, 12].includes(menuItem.party_post_group_id)) {
            //ஒன்றியம்
            data.cons_circle_id = menuItem.cons_circle_id;
          } else if ([11, 19].includes(menuItem.party_post_group_id)) {
            data.section_id = menuItem.section_id;
            data.section_name = menuItem.place_name;
          }

          let key = this.helper.storePageData(data);
          this._router.navigate(["/post/constituency", key]);
        } else if (menuItem.lp == Constants.CHIEF_SENEGAL_EXECUTIVE) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data = {
            country_id: country_id,
            country_name: country_name,
            barrack_id: menuItem.barrack_id,
            party_post_id: menuItem.party_post_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            lp: menuItem.lp,
            lp_party_post_subgroup_id: menuItem.party_post_subgroup_id,
            party_post_group_id: menuItem.party_post_group_id,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };
          let key = this.helper.storePageData(data);
          this._router.navigate([
            "/post/chief_senegal_executive",
            key,
            // menuItem.party_post_id,
            // menuItem.party_post_subgroup_id,
            // menuItem.barrack_id,
            // country_id,
            // menuItem.party_post_subgroup_name,
            // menuItem.barrack_name,
          ]);
        } else if (menuItem.lp == Constants.EXECUTIVE_SECRETARY_OF_PARLIAMENT) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data = {
            loksabha_cons_id: menuItem.loksabha_cons_id,
            loksabha_cons_name: menuItem.loksabha_cons_name,
            country_name: country_name,
            country_id: country_id,
            lp: menuItem.lp,
            barrack_id: menuItem.barrack_id,
            party_post_id: menuItem.party_post_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            lp_party_post_subgroup_id: menuItem.party_post_subgroup_id,
            party_post_group_id: menuItem.party_post_group_id,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };
          let key = this.helper.storePageData(data);
          this._router.navigate([
            "/post/loksabha_processor_administrator",
            key,
          ]);
        } else if (menuItem.lp == Constants.ZONE_LP) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data = {
            country_name: country_name,
            country_id: country_id,
            lp: menuItem.lp,
            zone_id: menuItem.zone_district_id,
            zone_name: menuItem.zone_district,
            barrack_id: menuItem.barrack_id,
            party_post_id: menuItem.party_post_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            lp_party_post_subgroup_id: menuItem.party_post_subgroup_id,
            party_post_group_id: menuItem.party_post_group_id,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };
          let key = this.helper.storePageData(data);
          this._router.navigate(["/post/zone_processor_administrator", key]);
        } else if (menuItem.lp == Constants.STATE_PROCESSOR_ADMINISTRATOR) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data = {
            party_post_id: menuItem.party_post_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            barrack_id: menuItem.barrack_id,
            country_id: country_id,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };
          let key = this.helper.storePageData(data);

          this._router.navigate([
            "/post/state_processor_administrator",
            key,
            // menuItem.party_post_id,
            // menuItem.party_post_subgroup_id,
            // menuItem.barrack_id,
            // country_id,
            // menuItem.party_post_subgroup_name,
            // menuItem.barrack_name,
          ]);
        } else if (menuItem.lp == Constants.DISTRICT_PROCESSOR_ADMINISTRATOR) {
          localStorage.setItem("dataSource", this.selected_role);
          this.ngOnInit();
          let data = {
            lp: menuItem.lp,
            barrack_id: menuItem.barrack_id,
            party_post_id: menuItem.party_post_id,
            party_post_subgroup_id: menuItem.party_post_subgroup_id,
            lp_party_post_subgroup_id: menuItem.party_post_subgroup_id,
            party_post_group_id: menuItem.party_post_group_id,
            district_id: menuItem.post_district_id,
            district_name: menuItem.post_district_name,
            party_post_subgroup_name: menuItem.party_post_subgroup_name,
            barrack_name: menuItem.barrack_name,
          };
          let key = this.helper.storePageData(data);
          this._router.navigate([
            "/post/district_processor_administrator",
            key,
          ]);
        }
      }
    };

    if (
      localStorage.getItem(this.helper.getMangledName("verified")) ==
      this.helper.getMangledName("1")
    ) {
      callback(1);
    } else {
      this.pinDialog = this._matDialog.open(PinViewComponent, {
        panelClass: "pin-view-dialog",
        data: { ...this.parameters, verify_callback: callback },
        disableClose: false,
      });
    }
  }

  get userData(): any {
    return this._userDataService.userData;
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  trackByFn(index, item) {
    return index;
  }

  getPartyPosts() {
    return this.userData?.party_posts?.filter((val) => {
      return val.status == 98;
    });
  }
}
